import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { IEnvironment } from 'src/environments/environment.model';
import { SettingsService } from 'src/app/modules/core/services/settings.service';
import { HomeDetails } from 'src/app/modules/core/models/sales.model';
import { UnsubscribeOnDestroy } from 'src/app/modules/shared/utilities/unsubscribe-on-destroy';
import { withSpinner } from 'src/app/modules/shared/extensions/withSpinner.extension';

@Injectable({
	providedIn: 'root'
})
export class SalesService extends UnsubscribeOnDestroy {	
	private settings!: IEnvironment;

	constructor(private _http: HttpClient,
		settingsService: SettingsService) {
		super();

		settingsService.getSettings().pipe(
			this.takeUntilDestroyed()
		).subscribe(settings => {
			this.settings = settings;
		});
	}

	getHomeDetails(salesAgreementId: number): Observable<HomeDetails> {
		const url = `${this.settings?.apiUrl}sales/salesAgreement/${salesAgreementId}/homeDetails`;
		return withSpinner(this._http).get<HomeDetails>(url);
	}

	getHomeDetailsViaSso(): Observable<HomeDetails> {
		const url = `${this.settings?.apiUrl}sales/sso/salesAgreement/homeDetails`;
		return withSpinner(this._http).get<HomeDetails>(url);
	}
}